import { Box } from '@mui/material';
import React from 'react';
import './index.scss';

interface FilterRowProps {
  children: React.ReactNode;
  /** Extra class on the row, for the rare page that needs to nudge it. */
  className?: string;
}

/**
 * A row of always-visible filter controls.
 *
 * The console had three ideas about where filters live and no rule about which to use:
 *
 *   - `CRMPageTemplate`'s panel — staged, commits on Apply. Right when a filter triggers a query.
 *   - `FilterBar` — also staged, for pages that are not CRM lists.
 *   - a row hand-rolled inline, per page — instant, and what six pages actually built.
 *
 * The third kept being rebuilt because it is genuinely needed: filtering a list already in memory
 * should not require an Apply click. What was wrong was that every page rebuilt the *layout*, so
 * six rows drifted to different gaps, alignments and control widths for the same thing.
 *
 * This owns only that layout. It has no state, no apply, no chips — the page keeps its own
 * filtering, unchanged. `CRMPageTemplate`'s `inlineFilters` prop renders one of these, so a CRM
 * list and an email page get an identical row without knowing about each other.
 *
 * The rule, in one line: **instant and client-side, use this; triggers a query, use the panel.
 * Never both on one page.**
 */
const FilterRow: React.FC<FilterRowProps> = ({ children, className }) => (
  <Box className={`cc-filter-row${className ? ` ${className}` : ''}`}>{children}</Box>
);

export default FilterRow;
